import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  deleteSubject,
  getDeleteSubjectStatus,
  getEditSubjectError,
  getEditSubjectStatus,
  setEditAndDeleteTopicandSubjectIdleStatus,
} from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import DeleteButton from "../common/DeleteButton";
import EditSubjectForm from "./EditSubjectForm";

const SubjectItem = ({ subject, topicId }) => {
  const [editActive, setEditActive] = useState(false);

  const editStatus = useSelector(getEditSubjectStatus);
  const deleteStatus = useSelector(getDeleteSubjectStatus);
  const deleteError = useSelector(getEditSubjectError);

  return (
    <>
      {editStatus === "loading" || deleteStatus === "loading" ? (
        <Loading />
      ) : null}
      {editStatus === "success" ? (
        <AlertBox
          type="success"
          message="Subject edited successfully"
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}

      {deleteStatus === "error" ? (
        <AlertBox
          type="success"
          message={deleteError}
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}
      {deleteStatus === "success" ? (
        <AlertBox
          type="success"
          message="Subject deleted successfully"
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}

      {/* Show edit box when edit button is clicked */}
      {editActive ? (
        <EditSubjectForm
          subject={subject}
          topicId={topicId}
          setEditActive={setEditActive}
        />
      ) : (
        <div className="col-span-3 h-14">
          <div className="bg-textSecondary/20 border border-textSecondary/20 rounded-[4px] py-2 hoverEffect flex flex-row justify-center items-center gap-3">
            <span className="text-textPrimary">{subject?.subjectName}</span>
            <div className="edit flex-row gap-3">
              <FaEdit
                onClick={() => setEditActive(true)}
                className="text-blue-700 cursor-pointer"
              />
              <DeleteButton
                data={subject._id}
                toDispatch={deleteSubject}
                type="Subject"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubjectItem;
